import { useMemo } from 'react';
import { PlansBillingController } from '../../../controllers';
import constant from '../../../utils/constant';

const useViewSubscriptionTx = ({ customerId }) => {
	const {
		isLoading,
		isFetching,
		currentPage,
		setCurrentPage,
		setSearchQuery,
		limit,
		setLimit,
		data,
	} = PlansBillingController.useGetSubsPayments({ customer: customerId });

	const subTransactions = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.transactions || [];
		}
		return [];
	}, [data]);

	const subscriptionTotalCounts = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.totalCounts;
		}
		return 0;
	}, [data]);

	return {
		isLoading,
		isFetching,
		limit,
		setLimit,
		subTransactions,
		subscriptionTotalCounts,
		currentPage,
		setCurrentPage,
		setSearchQuery,
	};
};

export default useViewSubscriptionTx;
